window.$ = jQuery;
import {init_preview_slider} from './slider';

export {MarkerClusterer} from '../../node_modules/googlemaps-v3-utility-library-latest/markerclusterer/src/markerclusterer'

MarkerClusterer.prototype.setupStyles_ = function() {
  if (this.styles_.length) {
    return;
  }

  for (var i = 0, size; size = this.sizes[i]; i++) {
    this.styles_.push({
      url: this.imagePath_ + (i + 1) + '.' + this.imageExtension_,
      height: size,
      width: size,
      textColor: '#fff',
    });
  }
};

function marker_bounds(markers) {
  const bounds = new google.maps.LatLngBounds();
  for (let marker of markers) {
    bounds.extend(marker.getPosition());
  }
  return bounds;
};


const $script = require('scriptjs');

function create_markers(infos, map) {
  let markers = [];
  for (let info of infos) {
    const marker = new MarkerWithLabel({
      icon: '/wp-content/uploads/images/icons/transparent.png',
      position: {lat: info.lat, lng: info.lng},
      labelContent: '<a href="' +
          encodeURIComponent(info.url).replace(/%2F/g, '/') +
          '" class="search-map-label-anchor"><div class="search-map-label-content">' +
          info.price + '</div></a>',
      labelClass: 'search-map-label',
      contextmenu: true,
    });
    marker.addListener('click', e => {
      if ($(window).width() >= 1200) {
        const id = info.url.split('/')[2];
        $.get(`/preview/${id}`, property => {
          const $track = $('.search-preview-slider-track');
          if ($track.data('unslick')) {
            $track.slick('unslick');
          }
          $track.empty();
          for (const image of property.images) {
            $track.append($('<div class="aspect-ratio-5-3">').html($('<img>', {
              src: image,
            })));
          }
          $('.search-preview-state-index').text('1');
          $('.search-preview-state-total').text(property.images.length);
          init_preview_slider();
          $('.search-preview-street').text(property.address.street);
          $('.search-preview-place').text(property.address.place);
          $('.search-preview-price').text(property.price);
          $('.search-preview-beds').text(property.beds);
          $('.search-preview-baths').text(property.baths);
          $('.search-preview-sqft').text(property.sqft);
          $('.search-preview-year').text(property.year);
          $('.search-preview-mls').text(id);
          $('.search-preview .btn').attr('href', property.url);
          const $container = $('.search-preview');
          $container.show();
          $(window).on('click.sp', e => {
            if (!$container.is(e.target) && $container.has(e.target).length === 0) {
              $('.search-preview').hide();
              $(window).off('click.sp');
            }
          });
        });
      } else {
        window.open(info.url, '_blank');
      }
    });
    markers.push(marker);
  }
  return markers;
}

function* bound_markers(bounds, markers) {
  if (!bounds) return [];
  for (let marker of markers) {
    if (bounds.contains(marker.getPosition())) {
      yield marker;
    }
  }
}

export function init_simple_map($map) {
  if (!$map.length) return;
  const marker = $map.data('marker') || {latitude: 38.25, longitude: -85.75};
  const map = new google.maps.Map($map[0], {
    zoom: parseInt($map.data('zoom'), 10) || 14,
    center: {lat: marker.latitude, lng: marker.longitude},
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
  });
  new google.maps.Marker({
    position: {lat: marker.latitude, lng: marker.longitude},
    map: map,
  });
}

export function init_map($map, map_style, reinit) {
  if (!$map.length) return;
  const center = $map.data('center') || {latitude: 38.25, longitude: -85.75};
  const initialized = $map.data('map');
  const map = initialized ? initialized : new google.maps.Map($map[0], {
    zoom: parseInt($map.data('zoom'), 10) || 9,
    center: {lat: center.latitude, lng: center.longitude},
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
  });
  if (!initialized) {
    $map.data('map', map);
    map.mapTypes.set('styled_map', map_style);
    map.setMapTypeId('styled_map');
  }
  $map.data('map-markers', create_markers($map.data('markers'), map));
  let clusterer = null;
  const detect_clusters = () => {
    const markers = $map.data('map-markers');
    const bounds = map.getBounds();
    const markers_in_bound = Array.from(bound_markers(bounds, markers));
    if (bounds && markers_in_bound.length <= 16) {
      if (markers_in_bound.length == 0) return;
      if (clusterer) clusterer.clearMarkers();
      for (let marker of markers_in_bound) {
        marker.setMap(map);
      }
      if (clusterer !== null) {
        clusterer = null;
        map.fitBounds(marker_bounds(markers_in_bound));
      }
    } else {
      if (clusterer !== null) return;
      const has_clusterer = $map.data('clusterer');
      if (!has_clusterer) {
        clusterer = new MarkerClusterer(map, markers, {
          imagePath: '/wp-content/uploads/images/icons/j',
        });
        $map.data('clusterer', clusterer);
      } else {
        clusterer = $map.data('clusterer');
        if (reinit) {
          clusterer.clearMarkers();
        }
        clusterer.addMarkers(markers);
      }
      if (markers_in_bound.length > 0) {
        map.fitBounds(marker_bounds(markers_in_bound));
      } else {
        clusterer.fitMapToMarkers();
      }
    }
  };
  if ($map.data('map-markers').length > 0) {
    detect_clusters();
  }
  if (!initialized) {
    map.addListener('bounds_changed', () => {
      detect_clusters();
    });
  }
}

function init() {
  const map_style = new google.maps.StyledMapType(
      map_style_options(), {name: 'Julie Pogue Properties'});
  init_map($('.map'), map_style);
  init_simple_map($('.simple-map'));
}

function initMap() {
  $script('/wp-content/themes/juliepogue/packed/markerwithlabel.js', init);
}

export function initalize() {
  window.initMap = initMap;
  $script(
      '//maps.googleapis.com/maps/api/js?key=AIzaSyDvMaYzRy3StfRuPfvZMgtKj5i6eeEESng&callback=initMap');
}

function map_style_options() {
  return [
    {'elementType': 'geometry', 'stylers': [{'color': '#ebe3cd'}]},
    {'elementType': 'labels.text.fill', 'stylers': [{'color': '#523735'}]},
    {'elementType': 'labels.text.stroke', 'stylers': [{'color': '#f5f1e6'}]},
    {
      'featureType': 'administrative',
      'elementType': 'geometry.stroke',
      'stylers': [{'color': '#c9b2a6'}]
    },
    {
      'featureType': 'administrative.land_parcel',
      'elementType': 'geometry.stroke',
      'stylers': [{'color': '#dcd2be'}]
    },
    {
      'featureType': 'administrative.land_parcel',
      'elementType': 'labels.text.fill',
      'stylers': [{'color': '#ae9e90'}]
    },
    {
      'featureType': 'landscape.natural',
      'elementType': 'geometry',
      'stylers': [{'color': '#dfd2ae'}]
    },
    {
      'featureType': 'poi',
      'elementType': 'geometry',
      'stylers': [{'color': '#dfd2ae'}]
    },
    {
      'featureType': 'poi',
      'elementType': 'labels.text.fill',
      'stylers': [{'color': '#93817c'}]
    },
    {
      'featureType': 'poi.park',
      'elementType': 'geometry.fill',
      'stylers': [{'color': '#a5b076'}]
    },
    {
      'featureType': 'poi.park',
      'elementType': 'labels.text.fill',
      'stylers': [{'color': '#447530'}]
    },
    {
      'featureType': 'road',
      'elementType': 'geometry',
      'stylers': [{'color': '#f5f1e6'}]
    },
    {
      'featureType': 'road.arterial',
      'elementType': 'geometry',
      'stylers': [{'color': '#fdfcf8'}]
    },
    {
      'featureType': 'road.highway',
      'elementType': 'geometry',
      'stylers': [{'color': '#f8c967'}]
    },
    {
      'featureType': 'road.highway',
      'elementType': 'geometry.stroke',
      'stylers': [{'color': '#e9bc62'}]
    },
    {
      'featureType': 'road.highway.controlled_access',
      'elementType': 'geometry',
      'stylers': [{'color': '#e98d58'}]
    },
    {
      'featureType': 'road.highway.controlled_access',
      'elementType': 'geometry.stroke',
      'stylers': [{'color': '#db8555'}]
    },
    {
      'featureType': 'road.local',
      'elementType': 'labels.text.fill',
      'stylers': [{'color': '#806b63'}]
    },
    {
      'featureType': 'transit.line',
      'elementType': 'geometry',
      'stylers': [{'color': '#dfd2ae'}]
    },
    {
      'featureType': 'transit.line',
      'elementType': 'labels.text.fill',
      'stylers': [{'color': '#8f7d77'}]
    },
    {
      'featureType': 'transit.line',
      'elementType': 'labels.text.stroke',
      'stylers': [{'color': '#ebe3cd'}]
    },
    {
      'featureType': 'transit.station',
      'elementType': 'geometry',
      'stylers': [{'color': '#dfd2ae'}]
    },
    {
      'featureType': 'water',
      'elementType': 'geometry.fill',
      'stylers': [{'color': '#b9d3c2'}]
    },
    {
      'featureType': 'water',
      'elementType': 'labels.text.fill',
      'stylers': [{'color': '#92998d'}]
    }
  ];
}
